// Include all styles you want in global 'css' object.
// To use this file:
// - import * as css from 'styles'
// - if above doesn't work, use relative path e.g: '../../styles'
// - example use: css.font.xxl or css.transition.fast

export * from './z-manager'
export * from './font'
export * from './color'
export * from './border'
export * from './space'
export * from './breakpoints'
export * from './transition'
export * from './form'
export * from './theme'
export * from './animations'



// WEBPACK FOOTER //
// ./src/styles/index.js